import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    date_range: [],
    territorial: [],
    GeoChartSett: {
      width: 'auto',
      height: 700,
      is3D: true,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 15
        },
        showColorCode: true
      },
      colors: ['#7ba6bd', '#085178']
    },
    BarChartSett: {
      width: 'auto',
      height: 600,
      is3D: true,
      colors: ['#085178'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 20
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      }
    }
  },

  mutations: {
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    },
    setTerritorialVideos(state, payload) {
      state.territorial = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readTerritorial({ commit, state }) {
      axios.api
        .get('report/data/territorial', {
          params: {
            start: format(
              subDays(new Date(state.date_range[1]), 1),
              'yyyy-MM-dd'
            ),
            end: state.date_range[1]
          }
        })
        .then(r => {
          commit('setTerritorialVideos', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          // commit('setLoading', false)
        })
    }
  },

  getters: {
    territorial_video: state => {
      return state.territorial[2]
    },
    territorial_views: state => {
      return state.territorial[1]
    },
    territorial_subscribers: state => {
      return state.territorial[0]
    }
  }
}
